var map = {
	"./about-card.de-CH.json": 1504,
	"./about-card.de-DE.json": 1505,
	"./about-card.en-CA.json": 1506,
	"./about-card.en-GB.json": 1507,
	"./about-card.en-IN.json": 1508,
	"./about-card.en-ME.json": 1509,
	"./about-card.en-US.json": 1510,
	"./about-card.es-EM.json": 1511,
	"./about-card.es-ES.json": 1512,
	"./about-card.fr-BE.json": 1513,
	"./about-card.fr-CA.json": 1514,
	"./about-card.fr-CH.json": 1515,
	"./about-card.nl-BE.json": 1516,
	"./about-card.nl-NL.json": 1517,
	"./about-card.pl-PL.json": 1518,
	"./about-card.pt-BR.json": 1519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1503;